import { VALIDATION_MESSAGES } from "../constants/messages";

export const REGEX_PATTERNS = {
  email: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
} as const;

const compileRegex = (pattern: string): RegExp => new RegExp(pattern);

export const REGEX = Object.fromEntries(
  Object.entries(REGEX_PATTERNS).map(([key, pattern]) => [key, compileRegex(pattern)])
) as { [K in keyof typeof REGEX_PATTERNS]: RegExp };

export type ValidationRule = {
  test: (value: string) => boolean;
  message: string;
};

export type ValidationRules = ValidationRule[];

export const matches = (regex: RegExp, message: string): ValidationRule => ({
  test: (value) => regex.test(value),
  message,
});

export const isEmail = (message = VALIDATION_MESSAGES.email.invalid): ValidationRule =>
  matches(REGEX.email, message);

export const validateAllMessages = (
  values: Record<string, string>,
  schema: Record<string, ValidationRule[]>
): Record<string, string[]> => {
  const errors: Record<string, string[]> = {};
  for (const field in schema) {
    const fieldErrors: string[] = [];
    for (const rule of schema[field]) {
      if (!rule.test(values[field] || "")) {
        fieldErrors.push(rule.message);
      }
    }
    errors[field] = fieldErrors;
  }
  return errors;
};
